/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerRerunInvestigationMutationResponse, IncidentInvestigationControllerRerunInvestigationPathParams, IncidentInvestigationControllerRerunInvestigationQueryParams } from "../../models/incidentAgentController/IncidentInvestigationControllerRerunInvestigation";

function getIncidentInvestigationControllerRerunInvestigationUrl(id: IncidentInvestigationControllerRerunInvestigationPathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/incident-agent/investigations/${id}/rerun` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/rerun}
 */
export async function incidentInvestigationControllerRerunInvestigation(id: IncidentInvestigationControllerRerunInvestigationPathParams["id"], params: IncidentInvestigationControllerRerunInvestigationQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerRerunInvestigationMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIncidentInvestigationControllerRerunInvestigationUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}